import { TTheme } from '@/core/theme'

export const drawerScrollFade = ({ theme }: { theme: TTheme }) => `
    .scrollable-parent {
        background:
            linear-gradient(
                    to top,
                    ${theme.colors.semantic.backgroundSecondary},
                    ${theme.colors.semantic.backgroundSecondary}
                )
                center bottom / 100% 48px no-repeat local,
            linear-gradient(
                    to top,
                    ${theme.colors.semantic.tableScrollShadow},
                    transparent
                )
                center bottom / 100% 48px no-repeat scroll;
    }
`
